import { VideoCameraIcon } from '@heroicons/react/24/outline';
import { IVideoClipResource, ResourceType } from '@packages/global';
import { useTranslation } from 'react-i18next';
import ResourceItem from './ResourceItem';

interface ResourceListProps {
  resources: IVideoClipResource[];
  onApply: (videoUrl: string) => void;
  onReuse: (params: any) => void;
  onDelete: (resourceId: string) => void;
}

export default function ResourceList({ resources, onApply, onReuse, onDelete }: ResourceListProps) {
  const { t } = useTranslation('editor');

  const filteredResources = resources
    .filter((r) => r.resourceType === ResourceType.VIDEO)
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());

  if (filteredResources.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        <VideoCameraIcon className="h-12 w-12 mx-auto mb-2 opacity-50" />
        <p className="text-sm">{t('videoGenForm.noRecords')}</p>
        <p className="text-xs mt-1">{t('videoGenForm.startBelow')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {filteredResources.map((resource) => (
        <ResourceItem
          key={resource.id}
          resource={resource}
          onApply={onApply}
          onReuse={onReuse}
          onDelete={() => onDelete(resource.id)}
        />
      ))}
    </div>
  );
}
